// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { ErrorsRoutingModule } from './errors-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { ErrorsComponent } from './errors.component';

/**
 * Errors Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Translate
    TranslateModule.forChild(),
    // Routing
    ErrorsRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
  ],
  declarations: [
    // Components
    ErrorsComponent,
  ],
})
export class ErrorsModule { }
